import React from "react";
import { NavLink } from "react-router-dom";
import { useState } from "react";
import { Theme } from "../Theme";
import { Container, Button, Typography, Box, Grid2, Grid } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import NI from "../assets/images/NI.svg";
import AI from "../assets/images/AI.png";
import CS from "../assets/images/cyber_security.png";
import DA from "../assets/images/data_analytics.png";
import HH from "../assets/images/home_page.png";
import Menu from "../assets/images/menu_img.png";
import About from "../assets/images/about_us.png";

export default function Home() {
  return (
    <ThemeProvider theme={Theme}>
      <Box
        sx={{
          padding: "0 20px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          background: "linear-gradient(135deg, #001d32 30%, #004080 100%)",
          minHeight: "100vh",
        }}
      >
        {/* Home */}
        <Grid2
          sx={{
            margin: "20px",
            marginTop: "0px",
            maxWidth: "1300px",
            minHeight: "750px",
            //height: "calc(100vh - 90px)", // Ensure full height (with header offset)
            width: "100%",
            backgroundColor: "#1a3953",
            borderRadius: "10px",
            padding: "0px 30px",
            boxShadow: "0 4px 10px rgba(0, 0, 0, 0.3)",
            marginBottom: "20px",
            display: "flex",
            //flexDirection: "row",
            alignItems: "center",
            //position: "relative",
          }}
        >
          <Grid
            container
            direction="row"
            alignItems={"center"}
            alignContent={"center"}
          >
            <Grid
              item
              xs={12}
              md={7}
              sx={{ display: { xs: "block", md: "none" } }}
            >
              {/* Image Section */}
              <Grid2
                sx={{
                  marginBottom: { xs: "20px", md: "0" }, // Full width on small screens
                  textAlign: "right",
                  display: "flex",
                  justifyContent: "flex-end", // Align image to the right
                }}
              >
                <img
                  style={{
                    height: "120%",
                    maxWidth: "100%", // Ensure responsive resizing
                    objectFit: "contain", // Maintain aspect ratio
                  }}
                  src={HH}
                  alt="Home"
                />
              </Grid2>
            </Grid>
            <Grid item xs={12} md={5}>
              {/* Text Section */}
              <Grid2
                sx={{
                  //width: { xs: "100%", md: "50%" }, // Full width on small screens
                  textAlign: { xs: "center", md: "left" }, // Center text on small screens
                }}
              >
                <Grid2 sx={{ display: { xs: "none", md: "block" } }}>
                  <img
                    style={{
                      objectFit: "contain", // Maintain aspect ratio
                      //transform: "rotate(-90deg)", // Rotate image 90 degree
                    }}
                    src={Menu}
                    alt="Menu"
                  />
                </Grid2>
                <Typography variant="h1">
                  We deliver solutions that enable organisations to enhance
                  their future
                </Typography>
                <Typography variant="body1">
                  By seamlessly integrating their network, data, decisions and
                  operations.
                </Typography>
                <Grid2
                  sx={{
                    display: "flex",
                    justifyContent: { xs: "center", md: "flex-start" }, // Center text on small screens,
                    alignItems: "center",
                    marginTop: "20px",
                  }}
                >
                  <NavLink to="/services" style={{ textDecoration: "none" }}>
                    <Typography
                      sx={{
                        fontSize: "20px",
                        padding: "10px 20px",
                        fontFamily: "Poppins",
                        width: "165px",
                        border: "1px solid white",
                        borderRadius: "8px",
                        color: "white",

                        "&:hover": {
                          color: "black", // Text color when hovered
                          backgroundColor: "white", // Background color when hovered
                        },
                      }}
                    >
                      Read More...
                    </Typography>
                  </NavLink>
                </Grid2>
              </Grid2>
            </Grid>
            <Grid
              item
              xs={12}
              md={7}
              sx={{ display: { xs: "none", md: "block" } }}
            >
              {/* Image Section */}
              <Grid2
                sx={{
                  marginTop: { xs: "20px", md: "0" }, // Full width on small screens
                  textAlign: "right",
                  display: "flex",
                  justifyContent: "flex-end", // Align image to the right
                }}
              >
                <img
                  style={{
                    height: "120%",
                    maxWidth: "100%", // Ensure responsive resizing
                    objectFit: "contain", // Maintain aspect ratio
                  }}
                  src={HH}
                  alt="Home"
                />
              </Grid2>
            </Grid>
          </Grid>
        </Grid2>

        {/* AboutUs */}
        <Grid2
          sx={{
            margin: "20px",
            maxWidth: "1300px",
            //height: "550px",
            //height: "calc(100vh - 90px)", // Ensure full height (with header offset)
            width: "100%",
            backgroundColor: "#1a3953",
            borderRadius: "10px",
            padding: "0px 30px",
            boxShadow: "0 4px 10px rgba(0, 0, 0, 0.3)",
            marginBottom: "20px",
            display: "flex",
            flexDirection: "column",
            //alignItems: "center",
            //position: "relative",
          }}
        >
          <Grid
            item
            xs={12}
            md={8}
            sx={{ display: { xs: "block", md: "none" } }}
          >
            {/* Image Section */}
            <Grid2
              sx={{
                marginBottom: { xs: "20px", md: "0" },
                textAlign: "right",
                display: "flex",
                justifyContent: "flex-end", // Align image to the right
                padding: "10px",
              }}
            >
              <img
                style={{
                  height: "100%",
                  maxWidth: "90%", // Ensure responsive resizing
                  objectFit: "contain", // Maintain aspect ratio
                }}
                src={About}
                alt="Home"
              />
            </Grid2>
          </Grid>
          <Grid2>
            <Grid
              container
              direction="row"
              alignItems={"center"}
              alignContent={"center"}
            >
              <Grid item xs={12} md={4}>
                {/* Text Section */}
                <Grid2
                  sx={{
                    //width: { xs: "100%", md: "50%" }, // Full width on small screens
                    textAlign: { xs: "center", md: "left" }, // Center text on small screens
                  }}
                >
                  <Typography variant="h1">About Us</Typography>
                  <Typography variant="body1">
                    We're a group of network infrastructure, data science and
                    business operations specialists with market leading
                    skillsets. We enhance your processes by integrating
                    intelligence deep into the core of your business.
                  </Typography>
                </Grid2>
                <Grid2
                  sx={{
                    display: "flex",
                    justifyContent: { xs: "center", md: "flex-start" }, // Center text on small screens,
                    alignItems: "center",
                    margin: { xs: "20px", md: "20px 0px" },
                  }}
                >
                  <NavLink to="/services" style={{ textDecoration: "none" }}>
                    <Typography
                      sx={{
                        fontSize: "20px",
                        padding: "10px 20px",
                        fontFamily: "Poppins",
                        width: "165px",
                        border: "1px solid white",
                        borderRadius: "8px",
                        color: "white",

                        "&:hover": {
                          color: "black", // Text color when hovered
                          backgroundColor: "white", // Background color when hovered
                        },
                      }}
                    >
                      Read More...
                    </Typography>
                  </NavLink>
                </Grid2>
              </Grid>
              <Grid
                item
                xs={12}
                md={8}
                sx={{ display: { xs: "none", md: "block" } }}
              >
                {/* Image Section */}
                <Grid2
                  sx={{
                    marginTop: { xs: "20px", md: "0" },
                    textAlign: "right",
                    display: "flex",
                    justifyContent: "flex-end", // Align image to the right
                    padding: "10px",
                  }}
                >
                  <img
                    style={{
                      height: "100%",
                      maxWidth: "90%", // Ensure responsive resizing
                      objectFit: "contain", // Maintain aspect ratio
                    }}
                    src={About}
                    alt="Home"
                  />
                </Grid2>
              </Grid>
            </Grid>
          </Grid2>
          <Grid2></Grid2>
        </Grid2>
        {/* Services */}
        <Grid2
          sx={{
            margin: "20px",
            maxWidth: "1300px",
            minHeight: "750px",
            //height: "calc(100vh - 90px)", // Ensure full height (with header offset)
            width: "100%",
            backgroundColor: "#1a3953",
            borderRadius: "10px",
            padding: "0px 30px",
            boxShadow: "0 4px 10px rgba(0, 0, 0, 0.3)",
            marginBottom: "20px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            //position: "relative",
          }}
        >
          <Typography variant="h1">Our Services</Typography>

          <Grid
            container
            direction="row"
            alignItems="center"
            alignContent="center"
            justifyContent="center"
            sx={{ textAlign: "center" }}
          >
            <Grid item xs={12} md={6}>
              <Grid2
                sx={{
                  background: "#001d32", // Add translucent background
                  borderRadius: "10px",
                  padding: "20px 30px",
                  boxShadow: "0 4px 10px rgba(0, 0, 0, 0.3)",
                  margin: "20px",
                  minHeight: "270px",
                  //justifyContent: "left",
                }}
              >
                <img
                  style={{
                    height: "60px",
                  }}
                  src={NI}
                  alt="Network Infrastructure"
                />
                <Typography variant="h2">Network Infrastructure</Typography>
                <Grid2>
                  <Typography variant="body1">
                    Empowering Digital Transformation with Robust Connectivity
                  </Typography>
                </Grid2>

                <Grid2
                  sx={{
                    width: "100%",
                    justifyItems: "center",
                  }}
                >
                  <Grid2
                    sx={{
                      border: "1px solid white",
                      borderRadius: "8px",
                      width: "165px",
                      marginTop: "20px",
                      "&:hover": {
                        color: "black", // Text color when hovered
                        backgroundColor: "white", // Background color when hovered
                      },
                    }}
                  >
                    <NavLink to="/services" style={{ textDecoration: "none" }}>
                      <Typography
                        sx={{
                          fontSize: "20px",
                          padding: "10px 20px",
                          fontFamily: "Poppins",
                          color: "white",
                          "&:hover": {
                            color: "black", // Text color when hovered
                          },
                        }}
                      >
                        Read More...
                      </Typography>
                    </NavLink>
                  </Grid2>
                </Grid2>
              </Grid2>
            </Grid>
            <Grid item xs={12} md={6}>
              <Grid2
                sx={{
                  background: "#001d32", // Add translucent background
                  borderRadius: "10px",
                  padding: "20px 30px",
                  boxShadow: "0 4px 10px rgba(0, 0, 0, 0.3)",
                  margin: "20px",
                  minHeight: "270px",
                }}
              >
                <img
                  style={{
                    height: "60px",
                  }}
                  src={DA}
                  alt="Data Analytics"
                />
                <Typography variant="h2">Data Analytics</Typography>
                <Grid2>
                  <Typography variant="body1">
                    Unlocking Actionable Insights for Smarter Decision-Making
                  </Typography>
                </Grid2>
                <Grid2
                  sx={{
                    width: "100%",
                    justifyItems: "center",
                  }}
                >
                  <Grid2
                    sx={{
                      border: "1px solid white",
                      borderRadius: "8px",
                      width: "165px",
                      marginTop: "20px",
                      "&:hover": {
                        color: "black", // Text color when hovered
                        backgroundColor: "white", // Background color when hovered
                      },
                    }}
                  >
                    <NavLink to="/services" style={{ textDecoration: "none" }}>
                      <Typography
                        sx={{
                          fontSize: "20px",
                          padding: "10px 20px",
                          fontFamily: "Poppins",
                          color: "white",
                          "&:hover": {
                            color: "black", // Text color when hovered
                          },
                        }}
                      >
                        Read More...
                      </Typography>
                    </NavLink>
                  </Grid2>
                </Grid2>
              </Grid2>
            </Grid>
            <Grid item xs={12} md={6}>
              <Grid2
                sx={{
                  background: "#001d32", // Add translucent background
                  borderRadius: "10px",
                  padding: "20px 30px",
                  boxShadow: "0 4px 10px rgba(0, 0, 0, 0.3)",
                  margin: "20px",
                  minHeight: "270px",
                }}
              >
                <img
                  style={{
                    height: "60px",
                  }}
                  src={CS}
                  alt="Network Security"
                />
                <Typography variant="h2">Network Security</Typography>
                <Grid2>
                  <Typography variant="body1">
                    Protecting Your Business from Emerging Cyber Threats
                  </Typography>
                </Grid2>
                <Grid2
                  sx={{
                    width: "100%",
                    justifyItems: "center",
                  }}
                >
                  <Grid2
                    sx={{
                      border: "1px solid white",
                      borderRadius: "8px",
                      width: "165px",
                      marginTop: "20px",
                      "&:hover": {
                        color: "black", // Text color when hovered
                        backgroundColor: "white", // Background color when hovered
                      },
                    }}
                  >
                    <NavLink to="/services" style={{ textDecoration: "none" }}>
                      <Typography
                        sx={{
                          fontSize: "20px",
                          padding: "10px 20px",
                          fontFamily: "Poppins",
                          color: "white",
                          "&:hover": {
                            color: "black", // Text color when hovered
                          },
                        }}
                      >
                        Read More...
                      </Typography>
                    </NavLink>
                  </Grid2>
                </Grid2>
              </Grid2>
            </Grid>
            <Grid item xs={12} md={6}>
              <Grid2
                sx={{
                  background: "#001d32", // Add translucent background
                  borderRadius: "10px",
                  padding: "20px 30px",
                  boxShadow: "0 4px 10px rgba(0, 0, 0, 0.3)",
                  margin: "20px",
                  minHeight: "270px",
                }}
              >
                <img
                  style={{
                    height: "60px",
                  }}
                  src={AI}
                  alt="AI and Advanced Reporting"
                />
                <Typography variant="h2">AI and Advanced Reporting</Typography>
                <Grid2>
                  <Typography variant="body1">
                    Transforming Your Business with Intelligent Automation
                  </Typography>
                </Grid2>
                <Grid2
                  sx={{
                    width: "100%",
                    justifyItems: "center",
                  }}
                >
                  <Grid2
                    sx={{
                      border: "1px solid white",
                      borderRadius: "8px",
                      width: "165px",
                      marginTop: "20px",
                      "&:hover": {
                        color: "black", // Text color when hovered
                        backgroundColor: "white", // Background color when hovered
                      },
                    }}
                  >
                    <NavLink to="/services" style={{ textDecoration: "none" }}>
                      <Typography
                        sx={{
                          fontSize: "20px",
                          padding: "10px 20px",
                          fontFamily: "Poppins",
                          color: "white",
                          "&:hover": {
                            color: "black", // Text color when hovered
                          },
                        }}
                      >
                        Read More...
                      </Typography>
                    </NavLink>
                  </Grid2>
                </Grid2>
              </Grid2>
            </Grid>
          </Grid>
        </Grid2>
      </Box>
    </ThemeProvider>
  );
}
